import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { mqMin } from 'utils/responsive';
import { TopHeader } from 'ui/components/panes/Header/TopHeader';

const BgWrapper = styled.div`
    background-color: var(--pale-blue);
    min-height: calc(100vh - var(--height-top-header));
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 16px;
`;

const Wrapper = styled.div`
    margin: 20px auto;
    padding: 40px 30px;
    border-radius: 12px;
    background-color: var(--white);
    max-width: 1000px;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: var(--font-medium);
    text-align: center;

    h4 {
        color: var(--dark-blue);
    }

    ${mqMin('SP')} {
        margin: 0 auto;
        width: 100%;
        padding: 30px 16px;
        font-size: 0.9rem;
        gap: 16px;
    }
`;

const Title = styled.div`
    font-size: var(--font-xxx-large);
    color: var(--main-color-blue);
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
`;

const CompleteText = styled.div`
    margin: 0 auto;
    font-size: var(--font-medium);
    line-height: 1.5;

    ${mqMin('SP')} {
        font-size: 0.9rem;
    }
`;

export const SentRegistrationMail: React.FC = () => {
    useEffect(() => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'conversion', {
                send_to: 'AW-17187238444/WobGCM6QkdgaEKzkwYNA',
                value: 1.0,
                currency: 'JPY',
            });
        }
    }, []);
    return (
        <>
            <TopHeader />
            <BgWrapper>
                <Wrapper>
                    <Title>確認用メールを送信しました</Title>
                    <CompleteText>
                        入力いただいたメールアドレス宛に確認用のメールを送信しました。
                        <br />
                        メールに記載されている認証URLをクリックして、本登録を行なってください。
                    </CompleteText>
                </Wrapper>
            </BgWrapper>
        </>
    );
};
